export enum ConnectorNames {
  MetaMask = 'metaMask',
  Injected = 'injected',
  WalletConnect = 'walletConnect',
  TrustWallet = 'trust',
  WalletLink = 'coinbaseWalletSDK',
}
